import { render, staticRenderFns } from "./approvePhoto.vue?vue&type=template&id=6feaea74&scoped=true"
import script from "./approvePhoto.vue?vue&type=script&lang=js"
export * from "./approvePhoto.vue?vue&type=script&lang=js"
import style0 from "./approvePhoto.vue?vue&type=style&index=0&id=6feaea74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feaea74",
  null
  
)

export default component.exports